module.exports = __webpack_public_path__ + "ecf9c0b950f991bb64a916881104a288.png";